export function getEndOfToday() {
  const now = new Date();

  const endOfToday = new Date(now);

  endOfToday.setHours(23, 59, 59, 999);

  return endOfToday;
}
